var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 7C11.8125 7.74592 11.5162 8.46129 10.9887 8.98874C10.4613 9.51618 9.74592 9.8125 9 9.8125C8.25408 9.8125 7.53871 9.51618 7.01126 8.98874C6.48382 8.46129 6.1875 7.74592 6.1875 7C6.1875 6.25408 6.48382 5.53871 7.01126 5.01126C7.53871 4.48382 8.25408 4.1875 9 4.1875C9.74592 4.1875 10.4613 4.48382 10.9887 5.01126C11.5162 5.53871 11.8125 6.25408 11.8125 7Z",
    fill: "#50CCB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 7 3.375 0.8125 9 0.8125C14.625 0.8125 18 7 18 7C18 7 14.625 13.1875 9 13.1875C3.375 13.1875 0 7 0 7ZM9 10.9375C10.0443 10.9375 11.0458 10.5227 11.7842 9.78423C12.5227 9.04581 12.9375 8.04429 12.9375 7C12.9375 5.95571 12.5227 4.95419 11.7842 4.21577C11.0458 3.47734 10.0443 3.0625 9 3.0625C7.95571 3.0625 6.95419 3.47734 6.21577 4.21577C5.47734 4.95419 5.0625 5.95571 5.0625 7C5.0625 8.04429 5.47734 9.04581 6.21577 9.78423C6.95419 10.5227 7.95571 10.9375 9 10.9375Z",
    fill: "#50CCB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.85108a5a84dcac8307c5d4f8077ee4c0.svg";
export { ForwardRef as ReactComponent };